/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EXPOSED_OVERHEAD_WORKING_SURFACES_SUCH_AS_WORKING_DOCKS_MEZZANI',
              'ALL_STAIRWAYS_ARE_EQUIPPED_WITH_HAND_RAILINGS_IN_GOOD_CONDITION',
              'ALL_FACILITY_STAIRWAY_STEPS_ARE_EVEN',
              'ALL_FACILITY_STEP_SURFACES_ARE_MADE_FROM_SLIP_RESISTANT_MATERIA',
              'PROTECTION_FROM_FALLING_OBJECTS_UNDERNEATH_GRADED_SURFACES',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_6: valueSchema,
  },
}
